module.exports = __webpack_public_path__ + "assets/img/discernment_license_scene1.b66c69d1.png";